import React, {FunctionComponent, useMemo} from "react";
import {ShapeType} from "../../enums";
import {BackgroundShapeProps} from "../../interfaces/strapi";

const styles = require("./backgroundShape.component.scss");

export const BackgroundShape: FunctionComponent<BackgroundShapeProps> = props => {
    const {shapeId, color, side, bottom} = props;

    const backgroundShape = useMemo(() => {
        switch (shapeId) {
            case ShapeType.none:
                return;
            case ShapeType.A1:
                return (
                    <svg width="445" height="600" viewBox="0 0 445 600" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-405.019 851.618C-414.573 846.282 -420.463 836.166 -420.389 825.223L-410.145 -684.205C-409.962 -711.258 -376.882 -724.266 -358.32 -704.584L436.31 138.029C447.677 150.083 447.121 169.07 435.067 180.438L-308.391 881.558C-317.918 890.543 -332.171 892.31 -343.604 885.924L-405.019 851.618Z"/>
                    </svg>
                );
            case ShapeType.A2:
                return (
                    <svg  viewBox="0 0 1443 508" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 -542.587C0 -548.632 5.32162 -553.295 11.314 -552.5L1585 -343.909V-61.2854L240.479 494.579C125.926 541.938 0 457.736 0 333.779L0 -542.587Z"/>
                    </svg>
                );
            case ShapeType.A3:
                return (
                    <svg width="328" height="554" viewBox="0 0 328 554" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-2.79025 546.363C104.306 576.217 214.751 511.114 240.494 402.956L328.202 34.4533C333.787 10.9895 308.477 -7.69646 287.702 4.553L-383.323 400.215C-400.633 410.421 -397.22 436.41 -377.862 441.807L-2.79025 546.363Z"/>
                    </svg>
                );
            case ShapeType.A4:
                return (
                    <svg width="212" height="529" viewBox="0 0 212 529" xmlns="http://www.w3.org/2000/svg">
                        <path d="M178.367 352.462C223.145 303.384 223.221 221.687 178.535 172.501L26.2864 4.91997C16.5922 -5.75043 0.418304 2.07781 0.405746 17.4463L-4.42172e-06 513.854C-0.0104724 526.66 13.4538 533.213 21.5477 524.341L178.367 352.462Z"/>
                    </svg>
                );
            case ShapeType.F1:
                return (
                    <svg className={styles.F1} width="324" height="296" viewBox="0 0 324 296" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-311.217 245.202C-336.885 259.257 -333.161 297.231 -305.251 306.03L241.876 478.521C248.357 480.564 255.268 476.967 257.311 470.485L320.213 270.966C325.897 252.937 324.048 233.376 315.085 216.731L219.562 39.3292C200.135 3.2501 155.043 -10.1049 119.101 9.57541L-311.217 245.202Z"/>
                    </svg>
                );
            case ShapeType.F2:
                return (
                    <svg className={`${styles.F2} ${side == "right" ? styles.right : ''}`} width="216" height="99" viewBox="0 0 216 99" xmlns="http://www.w3.org/2000/svg">
                        <path d="M71.9266 15.7054C91.9878 -5.20492 125.383 -5.24047 145.489 15.6271L213.99 86.7243C218.352 91.2513 215.152 98.8042 208.87 98.8101L5.95502 98.9995C0.72066 99.0044 -1.95797 92.7168 1.66823 88.9371L71.9266 15.7054Z"/>
                    </svg>
                );
            case ShapeType.F3:
                return (
                    <svg className={`${styles.F3} ${side == "right" ? styles.right : ''}`} width="141" height="295" viewBox="0 0 141 238" xmlns="http://www.w3.org/2000/svg">
                        <path d="M133.748 235.709C138.276 233.086 141.017 228.206 140.902 222.975L136.63 29.7562C136.033 2.70635 102.752 -9.79215 84.4962 10.177L8.07464 93.7691C-3.10485 105.998 -2.2545 124.974 9.97396 136.153L116.874 233.883C121.497 238.109 128.327 238.849 133.748 235.709Z"/>
                    </svg>

                );

        }
    }, [shapeId]);

    return (
        <div className={`${styles.shapeContainer} ${styles[color]} ${styles[side]} ${bottom ? styles.bottom : styles.top}`}>
            {backgroundShape}
        </div>
    );
};
